import "~/misc/common";
import { p, roundTo } from "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import L from "~/misc/2d/leaflet";
import type { FeatureCollection, GeoJsonProperties, Geometry } from 'geojson';

export default class extends Controller {
  connect() {
    console.log('airspaces_map.ts');

    const states = $('#toJs').data('states');
    p(states);

    const map = L.map('mapol').setView([47.497913, 19.040236], 13);
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(map);
    const data: FeatureCollection<Geometry, GeoJsonProperties> = {
      type: 'FeatureCollection',
      features: [],
    };
    states.forEach((feature: any) => {
      data.features.push(feature);
    });
    p(data);

    const featureGroup = L.geoJSON(data, {
      style: (feature) => feature?.properties || {},
    })
      .bindPopup((layer: any) => layer.feature?.properties?.name)
      .addTo(map);
    map.fitBounds(featureGroup.getBounds());
  }
}